import { mountSearchspringBadges } from "../../snippets/ss-badges/mountSearchspringBadges";

const ROOT_SELECTOR = ".pair-it-with";
const CARD_SELECTOR = ".card-wrapper.product-card-wrapper";
const LINK_SELECTOR = 'a[href*="/products/"]';
const OVERLAY_SELECTOR = ".ss__overlay-badge";

const getSiteId = (): string => document.body.dataset.ssSiteId?.trim() ?? "";

const getHandleFromCard = (card: HTMLElement): string => {
  const href =
    card.querySelector<HTMLAnchorElement>(LINK_SELECTOR)?.getAttribute("href") ??
    "";
  if (!href) return "";
  const match = href.match(/\/products\/([^/?#]+)/);
  return match?.[1]?.trim() ?? "";
};

const mountBadgesInRoot = async (root: HTMLElement): Promise<void> => {
  const siteId = getSiteId();
  if (!siteId) return;

  const cards = root.querySelectorAll<HTMLElement>(CARD_SELECTOR);
  if (!cards.length) return;

  await mountSearchspringBadges({
    siteId,
    cards,
    getHandleFromCard,
    shouldSkipCard: (card) => Boolean(card.querySelector(OVERLAY_SELECTOR)),
  });
};

const mountIn = (container: ParentNode): void => {
  container.querySelectorAll<HTMLElement>(ROOT_SELECTOR).forEach((root) => {
    void mountBadgesInRoot(root);
  });
};

mountIn(document);

document.addEventListener("shopify:section:load", (event) => {
  if (!(event.target instanceof HTMLElement)) return;
  mountIn(event.target);
});
